var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuArcana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9753 0.114064C15.8538 0.124979 18.7496 1.0652 21.1773 2.99127C26.9128 7.54149 27.864 15.8669 23.3016 21.5871C18.7392 27.3072 10.3914 28.2559 4.65593 23.7057C2.22822 21.7796 0.658169 19.1773 0 16.3824C0.397986 20.2142 2.27996 23.8902 5.54195 26.4782C11.9794 31.5851 21.3489 30.5208 26.4695 24.1006C31.5901 17.6804 30.523 8.33584 24.0856 3.22893C20.8236 0.640992 16.8094 -0.360755 12.9758 0.114064H12.9753Z",
    fill: "url(#paint0_linear_290_12637)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5988 23.7067L18.6087 24.5604L18.7574 23.6694L19.5988 23.7067L20.0067 23.9539L19.9575 22.9395L19.5988 23.7067Z",
    fill: "url(#paint1_linear_290_12637)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0067 23.9543L18.6087 24.5608L19.5988 23.707L20.0067 23.9543Z",
    fill: "url(#paint2_linear_290_12637)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9575 22.9395L18.7574 23.6694L19.5988 23.7067L19.9575 22.9395Z",
    fill: "url(#paint3_linear_290_12637)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7338 27.2324L13.3905 27.52L13.6875 28.5315L13.7338 27.2324Z",
    fill: "url(#paint4_linear_290_12637)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7338 27.2324L14.1328 27.5479L13.6875 28.5315",
    fill: "url(#paint5_linear_290_12637)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64046 23.9814L13.2174 28.4543L12.9298 27.0622L7.64046 23.9814Z",
    fill: "url(#paint6_linear_290_12637)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2173 28.4543L9.16242 26.9323L7.64045 23.9814L9.8117 26.6259L13.2173 28.4543Z",
    fill: "url(#paint7_linear_290_12637)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9298 27.0622L12.4845 26.3661L7.64045 23.9814L9.8117 26.6259L9.16242 26.9323L7.64045 23.9814L9.8117 26.6259L13.2173 28.4543L12.9298 27.0622Z",
    fill: "url(#paint8_linear_290_12637)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2174 28.4543L7.64046 23.9814L12.9298 27.0622L13.2174 28.4543Z",
    fill: "url(#paint9_linear_290_12637)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64046 23.9814L9.81171 26.6259L9.16242 26.9323L7.64046 23.9814Z",
    fill: "url(#paint10_linear_290_12637)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.323 23.372L16.4155 23.1401L17.4365 22.8247L18.1415 22.9824L17.8076 24.0775L16.7036 23.9287L16.323 23.372Z",
    fill: "url(#paint11_linear_290_12637)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4365 22.8247L16.7036 23.9287L18.1415 22.9824",
    fill: "url(#paint12_linear_290_12637)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8076 24.0776L15.5433 25.5065L16.323 23.3721L16.7036 23.9288L15.5433 25.5065L16.7036 23.9288L17.8076 24.0776Z",
    fill: "url(#paint13_linear_290_12637)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7036 23.9282L15.5433 25.5059L17.8076 24.077L16.7036 23.9282Z",
    fill: "url(#paint14_linear_290_12637)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6785 26.8989L21.3123 28.5836V27.8209L22.6785 26.8989Z",
    fill: "url(#paint15_linear_290_12637)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3123 28.5834L16.926 28.8536L21.3123 27.8207L20.5018 26.7241L22.6785 26.8987L21.3123 27.8207V28.5834Z",
    fill: "url(#paint16_linear_290_12637)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.926 28.8536L20.5018 26.7241L21.3123 27.8207L16.926 28.8536Z",
    fill: "url(#paint17_linear_290_12637)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8188 15.7344L11.7446 16.4767L12.0233 16.9314L12.3203 16.2822L11.8188 15.7344Z",
    fill: "url(#paint18_linear_290_12637)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8188 15.7344L11.9491 16.421L12.3203 16.2822",
    fill: "url(#paint19_linear_290_12637)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7446 16.4761L11.9491 16.4204L12.0233 16.9309",
    fill: "url(#paint20_linear_290_12637)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1406 20.9413L11.2645 19.3169L12.0486 20.5388L11.5197 20.4851L11.1406 20.9413Z",
    fill: "url(#paint21_linear_290_12637)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2645 19.3169L11.5197 20.4851L12.0073 21.8285L12.0486 20.5388L12.0073 21.8285L11.1406 20.9413L11.5197 20.4851L12.0486 20.5388",
    fill: "url(#paint22_linear_290_12637)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0486 20.5386L11.5198 20.4849L12.0073 21.8282",
    fill: "url(#paint23_linear_290_12637)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1178 11.1396L12.7308 12.3317L13.0571 13.1024L13.7228 12.29L13.1178 11.1396Z",
    fill: "url(#paint24_linear_290_12637)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1178 11.1396L13.2855 11.9671L13.7228 12.29L13.1178 11.1396Z",
    fill: "url(#paint25_linear_290_12637)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7307 12.3315L13.2855 11.9668L13.0571 13.1022L12.7307 12.3315Z",
    fill: "url(#paint26_linear_290_12637)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6872 20.6147L16.6225 21.4685L16.8727 21.7929L17.0862 21.2551L16.6872 20.6147Z",
    fill: "url(#paint27_linear_290_12637)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0862 21.2551L16.6872 20.6147L16.8359 21.3571L17.0862 21.2551L16.8359 21.3571L16.6225 21.4685L16.8359 21.3571L16.8727 21.7929L16.6225 21.4685L16.6872 20.6147",
    fill: "url(#paint28_linear_290_12637)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8727 21.7927L17.0862 21.2549L16.8359 21.3569L16.8727 21.7927Z",
    fill: "url(#paint29_linear_290_12637)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6225 21.4689L16.8359 21.3574L16.8727 21.7933",
    fill: "url(#paint30_linear_290_12637)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6872 20.6147L16.8359 21.3571L17.0862 21.2551",
    fill: "url(#paint31_linear_290_12637)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8578 17.1953L15.6418 19.2631L15.3314 19.6019L15.1373 17.5958L15.5732 17.8068L16.8578 17.1953Z",
    fill: "url(#paint32_linear_290_12637)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5732 17.8061L15.4876 16.813L15.1373 17.5951L15.5732 17.8061L16.8578 17.1946L16.0831 16.1289",
    fill: "url(#paint33_linear_290_12637)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8578 17.1946L15.6418 19.2624L15.3314 19.6012L15.5732 17.8061L16.0832 16.1289L15.4876 16.813L15.5732 17.8061",
    fill: "url(#paint34_linear_290_12637)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6418 19.2624L15.5732 17.8062L15.3314 19.6013L15.6418 19.2624Z",
    fill: "url(#paint35_linear_290_12637)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8052 15.7793L19.3425 16.4107L19.4674 16.5097L19.4007 15.8395L19.2704 15.9276L18.8052 15.7793Z",
    fill: "url(#paint36_linear_290_12637)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2704 15.9274L19.2341 15.596L19.4007 15.8393L19.2704 15.9274L18.8052 15.7791L18.9923 15.395",
    fill: "url(#paint37_linear_290_12637)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8052 15.7791L19.3425 16.4105L19.4674 16.5095L19.2704 15.9274L18.9923 15.395L19.2341 15.596L19.2704 15.9274",
    fill: "url(#paint38_linear_290_12637)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3425 16.4108L19.2704 15.9277L19.4674 16.5098L19.3425 16.4108Z",
    fill: "url(#paint39_linear_290_12637)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40462 17.291L6.74837 17.8169L7.20312 17.6766L7.40462 17.291Z",
    fill: "url(#paint40_linear_290_12637)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20411 17.6747L7.34989 17.8767L7.77678 18.4702L7.59567 19.4384L7.37327 19.9997L7.21804 19.4171L6.46129 18.7563L6.74936 17.815L7.40561 17.2886L7.20411 17.6747Z",
    fill: "url(#paint41_linear_290_12637)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21848 19.4165L6.46173 18.7558L6.89956 19.5698L7.37322 19.9992L7.21848 19.4165L7.77722 18.4697L7.40556 17.2886L7.21848 19.4165Z",
    fill: "url(#paint42_linear_290_12637)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37327 19.9992L6.89962 19.5698L6.46178 18.7559L7.21854 19.4166L7.37327 19.9992Z",
    fill: "url(#paint43_linear_290_12637)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77727 18.4697L7.21854 19.4165L7.37327 19.9991L7.59567 19.4384L7.77727 18.4697Z",
    fill: "url(#paint44_linear_290_12637)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74937 17.815L7.20411 17.6747L7.40562 17.2886L6.74937 17.815Z",
    fill: "url(#paint45_linear_290_12637)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40561 17.2886L7.20411 17.6747L7.35337 17.8841L7.21854 19.4165L7.77727 18.4697L7.40561 17.2886Z",
    fill: "url(#paint46_linear_290_12637)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35337 17.8841L7.40561 17.2886L7.20411 17.6747",
    fill: "url(#paint47_linear_290_12637)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36476 23.0418L6.31898 22.5174L6.59661 22.2139L6.36476 23.0418Z",
    fill: "url(#paint48_linear_290_12637)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9135 22.313L6.16326 21.8394L6.59662 22.214L6.16326 21.8394L6.31899 22.5175L5.9135 22.313L6.36476 23.0419L6.31899 22.5175L6.59662 22.214L6.31899 22.5175L6.16326 21.8394L6.31899 22.5175L6.59662 22.214L6.16326 21.8394L5.9135 22.313Z",
    fill: "url(#paint49_linear_290_12637)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31899 22.5175L6.16326 21.8394L5.9135 22.313L6.31899 22.5175L6.59662 22.214L6.31899 22.5175Z",
    fill: "url(#paint50_linear_290_12637)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3245 13.0522L16.3712 13.5533L16.8071 13.7573L17.1504 13.7946L16.7887 13.2473L16.3245 13.0522Z",
    fill: "url(#paint51_linear_290_12637)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6484 13.3442L16.9558 13.0337L16.6484 13.3442L16.3245 13.0521L16.9558 13.0337L17.1504 13.7944",
    fill: "url(#paint52_linear_290_12637)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6484 13.3442L16.9558 13.0337L16.3245 13.0521L16.6484 13.3442L16.3712 13.5531L16.8071 13.7571",
    fill: "url(#paint53_linear_290_12637)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81518 13.6274L9.2858 14.2399L9.25794 14.6946L9.76842 14.212L9.5087 14.2399L9.25794 14.6946L9.5087 14.2399H9.2858H9.5087L9.81518 13.6274Z",
    fill: "url(#paint54_linear_290_12637)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76842 14.2124L9.5087 14.2403L9.25794 14.695L9.76842 14.2124Z",
    fill: "url(#paint55_linear_290_12637)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76842 14.212L9.81518 13.6274L9.5087 14.2399H9.2858L9.25794 14.6946L9.5087 14.2399L9.76842 14.212Z",
    fill: "url(#paint56_linear_290_12637)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81518 13.6276L9.2863 14.2401H9.5092C9.5092 14.2401 9.81518 13.6162 9.81518 13.6276Z",
    fill: "url(#paint57_linear_290_12637)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58129 27.0133L7.23147 26.6646L7.07275 26.674L8.58129 27.0133Z",
    fill: "url(#paint58_linear_290_12637)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95833 25.8018L7.05485 25.0664L6.77374 25.765L6.95833 25.8018L7.23148 26.6655L7.07276 26.6749L6.77374 25.765",
    fill: "url(#paint59_linear_290_12637)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23148 26.6655L7.05485 25.0664L6.95833 25.8018L6.77374 25.765L7.07276 26.6749L8.58129 27.0143L8.27431 26.6043L7.5295 25.353L7.05485 25.0664L8.27431 26.6043L7.23148 26.6655L8.58129 27.0143L7.23148 26.6655Z",
    fill: "url(#paint60_linear_290_12637)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23147 26.6647L6.95832 25.801L6.77374 25.7642L7.07276 26.6742L7.23147 26.6647Z",
    fill: "url(#paint61_linear_290_12637)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95832 25.8018L7.23147 26.6655L8.27431 26.6043L7.05484 25.0664L6.95832 25.8018Z",
    fill: "url(#paint62_linear_290_12637)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95832 25.801L7.23147 26.6647L7.07276 26.6742L6.77374 25.7642L6.95832 25.801Z",
    fill: "url(#paint63_linear_290_12637)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27432 26.6035L8.20615 26.916L8.5813 27.0135",
    fill: "url(#paint64_linear_290_12637)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M12.676 24.7274L13.6691 23.3169L12.073 24.6717L12.676 24.7274L14.7547 24.7463L15.2557 24.5513L13.6691 23.3169L12.073 24.6717L12.676 24.7274L13.7248 27.131L12.073 24.6717L13.6691 23.3169L12.676 24.7274Z",
    fill: "url(#paint65_linear_290_12637)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7248 27.131L12.676 24.7274L14.7547 24.7463L12.676 24.7274L13.6691 23.3169L14.7547 24.7463L13.7248 27.131L15.2557 24.5513L13.7248 27.131Z",
    fill: "url(#paint66_linear_290_12637)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7248 27.1307L12.676 24.7271L14.7547 24.746L13.7248 27.1307Z",
    fill: "url(#paint67_linear_290_12637)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6691 23.3169L14.7547 24.7463L15.2557 24.5513L13.6691 23.3169Z",
    fill: "url(#paint68_linear_290_12637)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M12.676 24.7274L13.6691 23.3169L12.073 24.6717L13.6691 23.3169L12.073 24.6717L12.676 24.7274L13.6691 23.3169L14.7547 24.7463L15.2557 24.5513L13.7248 27.131L14.7547 24.7463L12.676 24.7274Z",
    fill: "url(#paint69_linear_290_12637)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M12.073 24.6714L12.676 24.7271L13.7248 27.1307L12.073 24.6714Z",
    fill: "url(#paint70_linear_290_12637)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6691 23.3169L12.676 24.7274L12.073 24.6717L13.6691 23.3169Z",
    fill: "url(#paint71_linear_290_12637)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0312 23.9308L9.64006 23.2158L9.98983 24.4129L11.0312 23.9308Z",
    fill: "url(#paint72_linear_290_12637)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14252 22.7417L9.6709 24.3975L9.98982 24.4129L9.64005 23.2159L9.14252 22.7417Z",
    fill: "url(#paint73_linear_290_12637)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64005 23.2159L11.0312 23.9308L11.1401 23.7288L9.14252 22.7417L9.64005 23.2159Z",
    fill: "url(#paint74_linear_290_12637)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98982 24.4133L11.6611 25.4551L11.0312 23.9312L9.98982 24.4133Z",
    fill: "url(#paint75_linear_290_12637)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0571 25.8361L11.1401 23.7295L12.0571 25.8361L9.67091 24.3982L9.98983 24.4136L11.6611 25.4554L12.0571 25.8361L11.6611 25.4554L12.0571 25.8361Z",
    fill: "url(#paint76_linear_290_12637)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14252 22.7417L9.6709 24.3975L9.98982 24.4129L9.64005 23.2159L9.14252 22.7417Z",
    fill: "url(#paint77_linear_290_12637)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1401 23.7295L11.0312 23.9315L11.6611 25.4554L12.0571 25.8361L11.1401 23.7295Z",
    fill: "url(#paint78_linear_290_12637)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M20.35 18.1299L20.3888 21.7594L21.5625 20.3753L21.576 20.3599L21.2018 19.8877L21.4023 19.4235L21.0839 18.7379L20.5043 18.3324L20.35 18.1299Z",
    fill: "url(#paint79_linear_290_12637)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5043 18.333L21.2018 19.8883L21.0839 18.7385",
    fill: "url(#paint80_linear_290_12637)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4023 19.4233L21.4894 19.6741L21.576 20.3597L21.2018 19.8875L20.3888 21.7593L21.576 20.3597L21.4023 19.4233Z",
    fill: "url(#paint81_linear_290_12637)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2018 19.8875L21.4023 19.4233L21.576 20.3597",
    fill: "url(#paint82_linear_290_12637)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M20.35 18.1299L20.7506 19.9543L20.3888 21.7594L20.35 18.1299Z",
    fill: "url(#paint83_linear_290_12637)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7506 19.9543L20.3645 19.8285L20.35 18.1299L20.7506 19.9543Z",
    fill: "url(#paint84_linear_290_12637)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0437 23.8628L20.3739 26.2256L21.7785 25.8798L21.7944 25.8758L21.773 25.3962L22.1193 25.1897L22.2337 24.5982L22.0486 24.0658L22.0437 23.8628Z",
    fill: "url(#paint85_linear_290_12637)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0486 24.0659L21.773 25.3963L22.2337 24.5983",
    fill: "url(#paint86_linear_290_12637)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1193 25.1899L22.0581 25.3924L21.7944 25.876L21.773 25.3964L20.3739 26.2258L21.7944 25.876L22.1193 25.1899Z",
    fill: "url(#paint87_linear_290_12637)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M21.773 25.3964L22.1193 25.1899L21.7944 25.876",
    fill: "url(#paint88_linear_290_12637)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0437 23.8628L21.4506 25.2285L20.3739 26.2256L22.0437 23.8628Z",
    fill: "url(#paint89_linear_290_12637)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4506 25.2285L21.2595 24.9673L22.0437 23.8628L21.4506 25.2285Z",
    fill: "url(#paint90_linear_290_12637)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2517 29.209L12.1377 29.6916L11.6183 31.0001L12.5153 30.1921L13.2517 29.209Z",
    fill: "url(#paint91_linear_290_12637)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5153 30.1921L13.2517 29.209L12.1377 29.6916L12.5153 30.1921L11.6183 31.0006L12.9357 30.4439",
    fill: "url(#paint92_linear_290_12637)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9357 30.4439L12.5153 30.1921L13.2517 29.21L12.9357 30.4439L12.5153 30.1921L12.9357 30.4439Z",
    fill: "url(#paint93_linear_290_12637)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5786 29.7007L16.7036 29.9882L16.5921 30.2947L14.6527 29.9977L14.5786 29.7007Z",
    fill: "url(#paint94_linear_290_12637)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8334 29.4595L16.7036 29.9883L14.5786 29.7008L13.7895 29.4968L16.8334 29.4595Z",
    fill: "url(#paint95_linear_290_12637)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6527 29.9974L14.5786 29.7004L16.7036 29.9879L16.5921 30.2944L16.7036 29.9879L18.7728 29.58L16.5921 30.2944L14.6527 29.9974L13.7895 29.4964L14.5786 29.7004L13.7895 29.4964L17.2787 28.9302L16.8334 29.4591L16.7036 29.9879L16.8334 29.4591L18.7728 29.58L17.2787 28.9302L16.8334 29.4591L13.7895 29.4964",
    fill: "url(#paint96_linear_290_12637)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7728 29.5804L16.8334 29.4595L16.7036 29.9883L18.7728 29.5804Z",
    fill: "url(#paint97_linear_290_12637)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8334 29.4591L17.2787 28.9302L13.7895 29.4964L16.8334 29.4591Z",
    fill: "url(#paint98_linear_290_12637)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1037 29.6646L13.1959 28.9775L9.16838 28.9686L8.84349 27.4839L6.63542 28.0312L9.16838 28.9686L9.1037 29.6646L6.63542 28.0312L8.84349 27.4839L11.7113 28.059L13.1959 28.9775L9.1037 29.6646L13.1959 28.9775L9.16838 28.9686L8.84349 27.4839L6.63542 28.0312L9.1037 29.6646L9.16838 28.9686L6.63542 28.0312",
    fill: "url(#paint99_linear_290_12637)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1959 28.9772L9.10371 29.6643L9.16839 28.9683L13.1959 28.9772Z",
    fill: "url(#paint100_linear_290_12637)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84349 27.4839L9.16838 28.9686L6.63542 28.0312L8.84349 27.4839Z",
    fill: "url(#paint101_linear_290_12637)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7113 28.059L8.84349 27.4839L9.16838 28.9686",
    fill: "url(#paint102_linear_290_12637)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8625 25.9642L19.3704 26.1752L19.0037 25.9995L20.6889 24.4482",
    fill: "url(#paint103_linear_290_12637)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5737 28.2355L18.2027 25.3493L20.6889 24.4482L19.8401 26.5787L19.8625 25.9642L20.6889 24.4482L19.0037 25.9995L18.2027 25.3493L20.6889 24.4482L19.0037 25.9995L18.2027 25.3493",
    fill: "url(#paint104_linear_290_12637)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5737 28.2358L18.4773 27.6268L18.037 27.5761L18.4773 27.6268L19.8401 26.579L19.3704 26.1755L18.037 27.5761L16.5737 28.2358L18.2027 25.3496L19.0037 25.9999L16.5737 28.2358Z",
    fill: "url(#paint105_linear_290_12637)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8625 25.9644L19.3704 26.1753L19.8401 26.5788L19.8625 25.9644Z",
    fill: "url(#paint106_linear_290_12637)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M18.037 27.5762L19.3704 26.1756L19.0037 26L16.5737 28.236L18.037 27.5762Z",
    fill: "url(#paint107_linear_290_12637)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9836 26.524L16.9693 25.2622L16.7096 26.9697L14.9836 26.524Z",
    fill: "url(#paint108_linear_290_12637)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9836 26.524L13.9626 28.6957L15.6981 28.2036L16.7096 26.9697L17.1548 26.9324L16.9693 25.2622L14.9836 26.524Z",
    fill: "url(#paint109_linear_290_12637)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0135 28.3053L15.6981 28.2033L16.7096 26.9694L17.1549 26.9321L16.0135 28.3053L13.9627 28.6954L15.6981 28.2033L16.0135 28.3053Z",
    fill: "url(#paint110_linear_290_12637)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7096 26.9697L14.9836 26.524L16.9693 25.2622L16.7096 26.9697Z",
    fill: "url(#paint111_linear_290_12637)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0135 28.3051L15.6981 28.2031L13.9627 28.6952L16.0135 28.3051Z",
    fill: "url(#paint112_linear_290_12637)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_290_12637",
    x1: 7.44738,
    y1: 3.733,
    x2: 22.9278,
    y2: 27.3016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_290_12637",
    x1: 18.6087,
    y1: 23.7499,
    x2: 20.0067,
    y2: 23.7499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_290_12637",
    x1: 18.6087,
    y1: 24.1339,
    x2: 20.0067,
    y2: 24.1339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_290_12637",
    x1: 18.7574,
    y1: 23.3231,
    x2: 19.9575,
    y2: 23.3231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_290_12637",
    x1: 13.3905,
    y1: 27.8822,
    x2: 13.7338,
    y2: 27.8822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_290_12637",
    x1: 13.6875,
    y1: 27.8822,
    x2: 14.1328,
    y2: 27.8822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_290_12637",
    x1: 7.64046,
    y1: 26.2179,
    x2: 13.2174,
    y2: 26.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_290_12637",
    x1: 10.4291,
    y1: 28.4543,
    x2: 10.4291,
    y2: 23.9814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_290_12637",
    x1: 7.64045,
    y1: 26.2179,
    x2: 13.2173,
    y2: 26.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_290_12637",
    x1: 7.64046,
    y1: 26.2179,
    x2: 13.2174,
    y2: 26.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_290_12637",
    x1: 7.64046,
    y1: 25.4566,
    x2: 9.81171,
    y2: 25.4566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_290_12637",
    x1: 16.323,
    y1: 23.4511,
    x2: 18.1415,
    y2: 23.4511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_290_12637",
    x1: 16.7036,
    y1: 23.377,
    x2: 18.1415,
    y2: 23.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_290_12637",
    x1: 15.5433,
    y1: 24.4393,
    x2: 17.8076,
    y2: 24.4393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_290_12637",
    x1: 15.5433,
    y1: 24.7173,
    x2: 17.8076,
    y2: 24.7173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_290_12637",
    x1: 21.3123,
    y1: 27.7413,
    x2: 22.6785,
    y2: 27.7413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_290_12637",
    x1: 16.926,
    y1: 27.7888,
    x2: 22.6785,
    y2: 27.7888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_290_12637",
    x1: 16.926,
    y1: 27.7888,
    x2: 21.3123,
    y2: 27.7888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_290_12637",
    x1: 11.7446,
    y1: 16.3329,
    x2: 12.3203,
    y2: 16.3329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_290_12637",
    x1: 11.8188,
    y1: 16.0777,
    x2: 12.3203,
    y2: 16.0777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_290_12637",
    x1: 11.7446,
    y1: 16.6756,
    x2: 12.0233,
    y2: 16.6756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_290_12637",
    x1: 11.609,
    y1: 20.9322,
    x2: 11.6028,
    y2: 19.3082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_290_12637",
    x1: 11.6124,
    y1: 21.8228,
    x2: 11.6028,
    y2: 19.3082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_290_12637",
    x1: 11.8025,
    y1: 21.8218,
    x2: 11.7973,
    y2: 20.4765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_290_12637",
    x1: 12.6781,
    y1: 12.321,
    x2: 13.5362,
    y2: 11.9001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_290_12637",
    x1: 13.2155,
    y1: 11.8147,
    x2: 13.4402,
    y2: 11.7045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_290_12637",
    x1: 12.858,
    y1: 12.6875,
    x2: 13.4914,
    y2: 12.3768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_290_12637",
    x1: 16.6225,
    y1: 21.2038,
    x2: 17.0862,
    y2: 21.2038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_290_12637",
    x1: 16.6225,
    y1: 21.2038,
    x2: 17.0862,
    y2: 21.2038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_290_12637",
    x1: 16.8359,
    y1: 21.5236,
    x2: 17.0862,
    y2: 21.5236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_290_12637",
    x1: 16.7479,
    y1: 21.7933,
    x2: 16.7479,
    y2: 21.3574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_290_12637",
    x1: 16.6872,
    y1: 20.9859,
    x2: 17.0862,
    y2: 20.9859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_290_12637",
    x1: 16.6487,
    y1: 16.9924,
    x2: 14.7747,
    y2: 19.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_290_12637",
    x1: 16.5569,
    y1: 16.5367,
    x2: 15.4084,
    y2: 17.8217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_290_12637",
    x1: 16.7327,
    y1: 16.6938,
    x2: 14.6734,
    y2: 18.9978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_290_12637",
    x1: 15.9476,
    y1: 18.1255,
    x2: 14.9483,
    y2: 19.2436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_290_12637",
    x1: 18.114,
    y1: 16.4461,
    x2: 18.8771,
    y2: 17.0648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_290_12637",
    x1: 18.1143,
    y1: 16.2911,
    x2: 18.5821,
    y2: 16.6702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_290_12637",
    x1: 18.0661,
    y1: 16.3505,
    x2: 18.9048,
    y2: 17.0304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_290_12637",
    x1: 18.4224,
    y1: 16.7936,
    x2: 18.8295,
    y2: 17.1236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_290_12637",
    x1: 6.89512,
    y1: 17.4835,
    x2: 7.30561,
    y2: 17.6329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_290_12637",
    x1: 6.58133,
    y1: 18.3457,
    x2: 7.85068,
    y2: 18.8077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_290_12637",
    x1: 6.63007,
    y1: 18.3629,
    x2: 7.83443,
    y2: 18.8012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_290_12637",
    x1: 6.33913,
    y1: 19.1624,
    x2: 7.54349,
    y2: 19.6008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_290_12637",
    x1: 7.34236,
    y1: 19.1452,
    x2: 7.68272,
    y2: 19.2691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_290_12637",
    x1: 6.89597,
    y1: 17.4812,
    x2: 7.30647,
    y2: 17.6306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_290_12637",
    x1: 7.02233,
    y1: 18.2425,
    x2: 7.78441,
    y2: 18.5199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_290_12637",
    x1: 7.27639,
    y1: 17.5445,
    x2: 7.47556,
    y2: 17.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_290_12637",
    x1: 6.73055,
    y1: 22.3048,
    x2: 6.19639,
    y2: 22.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_290_12637",
    x1: 6.53297,
    y1: 22.0988,
    x2: 5.9988,
    y2: 22.6107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_290_12637",
    x1: 6.39114,
    y1: 21.9508,
    x2: 5.98558,
    y2: 22.3394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_290_12637",
    x1: 16.3245,
    y1: 13.4234,
    x2: 17.1504,
    y2: 13.4234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_290_12637",
    x1: 16.3245,
    y1: 13.4138,
    x2: 17.1504,
    y2: 13.4138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_290_12637",
    x1: 16.3245,
    y1: 13.3954,
    x2: 16.9558,
    y2: 13.3954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_290_12637",
    x1: 9.25794,
    y1: 14.1608,
    x2: 9.81518,
    y2: 14.1608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_290_12637",
    x1: 9.25794,
    y1: 14.4537,
    x2: 9.76842,
    y2: 14.4537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_290_12637",
    x1: 9.25794,
    y1: 14.1608,
    x2: 9.81518,
    y2: 14.1608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_290_12637",
    x1: 9.2858,
    y1: 13.9336,
    x2: 9.81518,
    y2: 13.9336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_290_12637",
    x1: 7.14144,
    y1: 26.9552,
    x2: 8.55658,
    y2: 26.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_290_12637",
    x1: 6.82109,
    y1: 25.918,
    x2: 7.20606,
    y2: 25.8551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_290_12637",
    x1: 6.86642,
    y1: 26.1955,
    x2: 8.42838,
    y2: 25.9403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_290_12637",
    x1: 6.87308,
    y1: 26.2354,
    x2: 7.17555,
    y2: 26.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_290_12637",
    x1: 7.00406,
    y1: 25.9426,
    x2: 8.15797,
    y2: 25.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_290_12637",
    x1: 6.87308,
    y1: 26.2354,
    x2: 7.17555,
    y2: 26.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_290_12637",
    x1: 8.21693,
    y1: 26.8422,
    x2: 8.56654,
    y2: 26.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_290_12637",
    x1: 12.073,
    y1: 25.224,
    x2: 15.2557,
    y2: 25.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_290_12637",
    x1: 12.676,
    y1: 25.224,
    x2: 15.2557,
    y2: 25.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_290_12637",
    x1: 12.676,
    y1: 25.9291,
    x2: 14.7547,
    y2: 25.9291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_290_12637",
    x1: 13.6691,
    y1: 24.0319,
    x2: 15.2557,
    y2: 24.0319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_290_12637",
    x1: 12.073,
    y1: 25.224,
    x2: 15.2557,
    y2: 25.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_290_12637",
    x1: 12.073,
    y1: 25.9013,
    x2: 13.7248,
    y2: 25.9013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_290_12637",
    x1: 12.073,
    y1: 24.0224,
    x2: 13.6691,
    y2: 24.0224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_290_12637",
    x1: 9.64006,
    y1: 23.8144,
    x2: 11.0312,
    y2: 23.8144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_290_12637",
    x1: 9.14252,
    y1: 23.5776,
    x2: 9.98982,
    y2: 23.5776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_290_12637",
    x1: 9.14252,
    y1: 23.3363,
    x2: 11.1401,
    y2: 23.3363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_290_12637",
    x1: 9.98982,
    y1: 24.6929,
    x2: 11.6611,
    y2: 24.6929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_290_12637",
    x1: 9.67091,
    y1: 24.7828,
    x2: 12.0571,
    y2: 24.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_290_12637",
    x1: 9.14252,
    y1: 23.5776,
    x2: 9.98982,
    y2: 23.5776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_290_12637",
    x1: 11.0312,
    y1: 24.7828,
    x2: 12.0571,
    y2: 24.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_290_12637",
    x1: 20.35,
    y1: 19.9444,
    x2: 21.576,
    y2: 19.9444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_290_12637",
    x1: 20.5043,
    y1: 19.1107,
    x2: 21.2018,
    y2: 19.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_290_12637",
    x1: 20.3888,
    y1: 20.5911,
    x2: 21.576,
    y2: 20.5911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_290_12637",
    x1: 21.2018,
    y1: 19.8915,
    x2: 21.576,
    y2: 19.8915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_290_12637",
    x1: 20.35,
    y1: 19.9444,
    x2: 20.7506,
    y2: 19.9444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_290_12637",
    x1: 20.35,
    y1: 19.0419,
    x2: 20.7506,
    y2: 19.0419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_290_12637",
    x1: 21.1765,
    y1: 25.0285,
    x2: 21.9685,
    y2: 25.6009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_290_12637",
    x1: 21.6659,
    y1: 24.5622,
    x2: 22.1164,
    y2: 24.8877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_290_12637",
    x1: 20.8993,
    y1: 25.4649,
    x2: 21.6662,
    y2: 26.0193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_290_12637",
    x1: 21.7517,
    y1: 25.3922,
    x2: 21.9933,
    y2: 25.5668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_290_12637",
    x1: 21.1765,
    y1: 25.0285,
    x2: 21.4354,
    y2: 25.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_290_12637",
    x1: 21.5977,
    y1: 24.4458,
    x2: 21.8566,
    y2: 24.6329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_290_12637",
    x1: 11.6183,
    y1: 30.1046,
    x2: 13.2517,
    y2: 30.1046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_290_12637",
    x1: 11.6183,
    y1: 30.1051,
    x2: 13.2517,
    y2: 30.1051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_290_12637",
    x1: 12.5153,
    y1: 29.8269,
    x2: 13.2517,
    y2: 29.8269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_290_12637",
    x1: 14.5786,
    y1: 29.9977,
    x2: 16.7036,
    y2: 29.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_290_12637",
    x1: 13.7895,
    y1: 29.7242,
    x2: 16.8334,
    y2: 29.7242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_290_12637",
    x1: 13.7895,
    y1: 29.6123,
    x2: 18.7728,
    y2: 29.6123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_290_12637",
    x1: 16.7036,
    y1: 29.7242,
    x2: 18.7728,
    y2: 29.7242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_290_12637",
    x1: 13.7895,
    y1: 29.2133,
    x2: 17.2787,
    y2: 29.2133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_290_12637",
    x1: 6.63542,
    y1: 28.574,
    x2: 13.1959,
    y2: 28.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_290_12637",
    x1: 9.10371,
    y1: 29.316,
    x2: 13.1959,
    y2: 29.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_290_12637",
    x1: 6.63542,
    y1: 28.2262,
    x2: 9.16838,
    y2: 28.2262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_290_12637",
    x1: 8.84349,
    y1: 28.2262,
    x2: 11.7113,
    y2: 28.2262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_290_12637",
    x1: 18.9324,
    y1: 25.489,
    x2: 20.8193,
    y2: 25.1833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_290_12637",
    x1: 16.3388,
    y1: 26.7129,
    x2: 20.9462,
    y2: 25.9667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_290_12637",
    x1: 16.3781,
    y1: 26.9559,
    x2: 19.8225,
    y2: 26.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_290_12637",
    x1: 19.4093,
    y1: 26.3423,
    x2: 19.922,
    y2: 26.2592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_290_12637",
    x1: 16.4397,
    y1: 27.3361,
    x2: 19.4902,
    y2: 26.8421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_290_12637",
    x1: 14.9836,
    y1: 26.116,
    x2: 16.9693,
    y2: 26.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_290_12637",
    x1: 13.9626,
    y1: 26.9787,
    x2: 17.1548,
    y2: 26.9787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_290_12637",
    x1: 13.9627,
    y1: 27.8138,
    x2: 17.1549,
    y2: 27.8138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_290_12637",
    x1: 14.9836,
    y1: 26.116,
    x2: 16.9693,
    y2: 26.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_290_12637",
    x1: 13.9627,
    y1: 28.4489,
    x2: 16.0135,
    y2: 28.4489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0EC2EA",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#34CCED",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#73DBF2",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7F1FA",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "white",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E0C6FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#953AFF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2AFF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArcana);
export default __webpack_public_path__ + "static/media/menu-arcana.25ed3ff382e5ac8f7eab0f24a19bd9ae.svg";
export { ForwardRef as ReactComponent };